export enum StatusEnum {
    Scheduled = 'scheduled',
    Past = 'past',
    Archived = 'archived',
    Draft = 'draft',
    InReview = 'in_review',
}
